<script lang="ts">
  export let image: string;
</script>

<svg
  width="675"
  height="650"
  viewBox="65 45 675 650"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <rect
    x="66.99"
    y="51"
    width="200"
    height="191.667"
    rx="95.833"
    fill="var(--vlt-lp-primary)"
  />
  <path
    d="M194.538 233.344c0-37.713 0-56.569 11.716-68.285 11.716-11.715 30.572-11.715 68.284-11.715h380c37.712 0 56.569 0 68.284 11.715 11.716 11.716 11.716 30.572 11.716 68.285v380c0 37.712 0 56.568-11.716 68.284-11.715 11.716-30.572 11.716-68.284 11.716h-380c-37.712 0-56.568 0-68.284-11.716-11.716-11.716-11.716-30.572-11.716-68.284v-380Z"
    fill="var(--vlt-lp-primary)"
  />
  <path
    d="M140.838 197.702c0-37.712 0-56.568 11.716-68.284 11.715-11.716 30.572-11.716 68.284-11.716h380c37.712 0 56.568 0 68.284 11.716 11.716 11.716 11.716 30.572 11.716 68.284v380c0 37.713 0 56.569-11.716 68.285-11.716 11.715-30.572 11.715-68.284 11.715h-380c-37.712 0-56.569 0-68.284-11.715-11.716-11.716-11.716-30.572-11.716-68.285v-380Z"
    fill="url(#image-decoration)"
  />
  <path
    d="M124.521 177c0-18.899.003-32.92 1.451-43.687 1.441-10.723 4.29-17.989 9.816-23.515 5.526-5.526 12.793-8.375 23.515-9.816 10.767-1.448 24.788-1.451 43.687-1.451h420c18.9 0 32.92.003 43.687 1.45 10.723 1.442 17.989 4.291 23.515 9.817s8.375 12.792 9.817 23.515c1.447 10.767 1.45 24.788 1.45 43.687v420c0 18.899-.003 32.92-1.45 43.687-1.442 10.723-4.291 17.989-9.817 23.515s-12.792 8.375-23.515 9.816c-10.767 1.448-24.787 1.451-43.687 1.451h-420c-18.899 0-32.92-.003-43.687-1.451-10.722-1.441-17.989-4.29-23.515-9.816-5.526-5.526-8.375-12.792-9.816-23.515-1.448-10.767-1.451-24.788-1.451-43.687V177Z"
    stroke="var(--vlt-lp-primary)"
    stroke-width="3.062"
  />
  <defs>
    <pattern
      id="image-decoration"
      patternContentUnits="userSpaceOnUse"
      width="1"
      height="1"
      x="0"
      y="0"
    >
      <image
        id="c"
        width="540"
        height="540"
        x="0"
        y="0"
        xlink:href={image}
        preserveAspectRatio="xMidYMin slice"
      />
    </pattern>
  </defs>
</svg>
